export default "__VITE_ASSET__BrP2zSV7__"